import React, { useState } from 'react';
import './css/Audiovisuel.css';
import { FaPlay, FaPause } from 'react-icons/fa'; // Importez les icônes

const Audiovisuelle = () => {
  const [playingIndex, setPlayingIndex] = useState(null); // Suivre l'index de la vidéo en cours de lecture
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState("");

  const videoItems = [
    {
      thumbnail: "/video/10.mp4",
      videoLink: "https://www.youtube.com/embed/Ny5bM-HCzAM",
      title: "Kiua - Amasom",
      description: "Arrangement/Enregistrement/Mixage/Création Sonore: Valentin Leverrier<br /><br />Dessins/Animation: Thomas Csaba<br />Réalisation: Anaïs Bajeux<br />Ecriture, Voix, Chant: Claire-Sophie Dagan<br />Batterie: Ananda Brandaõ<br />Guitare: Quentin GOURAUD<br />Bass: Raphael Olive<br />Clavier: Benjamin Gobinet",
    },
    {
      thumbnail: "/video/9.mp4",
      videoLink: "https://www.youtube.com/embed/DQmVTXxFgew",
      title: "Capsule Sonore #09",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/8.mp4",
      videoLink: "https://www.youtube.com/embed/U_fn_FYRYgo",
      title: "Capsule Sonore #08",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/5.mp4",
      videoLink: "https://www.youtube.com/embed/ar4M-a9L3so",
      title: "Capsule Sonore #05",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/6.mp4",
      videoLink: "https://www.youtube.com/embed/Xug24P07GRI",
      title: "Capsule Sonore #06",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/1.mp4",
      videoLink: "https://www.youtube.com/embed/Iy71V6nIn4o",
      title: "Capsule Sonore #01",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",    },
    {
      thumbnail: "/video/2.mp4",
      videoLink: "https://www.youtube.com/embed/zA0YyuTGShs",
      title: "Capsule Sonore #02",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/3.mp4",
      videoLink: "https://www.youtube.com/embed/YFvgxl2ume0",
      title: "Capsule Sonore #03",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },
    {
      thumbnail: "/video/4.mp4",
      videoLink: "https://www.youtube.com/embed/eBsn9suhgDg",
      title: "Capsule Sonore #04",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },


    {
      thumbnail: "/video/7.mp4",
      videoLink: "https://www.youtube.com/embed/t1gJC48gZIw",
      title: "Capsule Sonore #07",
      description: "Dessins/Animation/Réalisation: Thomas Csaba<br />Composition: Valentin Leverrier",
    },



    // Ajoutez d'autres vidéos ici
  ];

  const toggleVideo = (index) => {
    if (playingIndex === index) {
      setPlayingIndex(null); // Arrête la lecture si la vidéo est déjà en cours
    } else {
      setPlayingIndex(index); // Démarre la lecture pour la vidéo sélectionnée
    }
  };

  const openPopup = (videoLink) => {
    setPopupContent(videoLink);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    setPopupContent("");
    setPlayingIndex(null); // Réinitialise l'état de lecture
  };

  return (
    <div className="audiovisuelle-section">
      <h6 className="section-title">Audiovisuel</h6> {/* Correction du texte et de la balise */}
      <h5 className="small-text">
  <a 
    href="https://www.instagram.com/thomas.csaba.illustration/"
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: 'none' }}
  >
    Dessins, animations et réalisation de Thomas Csaba
  </a>
</h5>
      <div className="video-thumbnails">
        {videoItems.map((video, index) => (
          <div
            key={index}
            className="video-item"
            onClick={() => openPopup(video.videoLink)}
          >
            <video
              src={video.thumbnail}
              className="video-thumbnail small-thumbnail" // Adjust size via CSS
              loop
              muted
              autoPlay
              playsInline
            />
            {/* Ajout de l'icône "play/pause" */}
            <div className="icon" onClick={() => toggleVideo(index)}>
              {playingIndex === index ? <FaPause /> : <FaPlay />}
            </div>
          </div>
        ))}
      </div>


  {popupVisible && (
    <div className="popup" onClick={closePopup}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <iframe
          className="video-frame"
          src={popupContent}
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          title="Video Player"
        ></iframe>
        {/* Ajout du titre et de la description */}
        <h3 className="text-small">
          {videoItems.find((video) => video.videoLink === popupContent)?.title}
        </h3>
        <p
  className="text-small"
  dangerouslySetInnerHTML={{
    __html: videoItems.find((video) => video.videoLink === popupContent)?.description,
  }}
></p>
      </div>
    </div>
  )}
    </div>
  );
};

export default Audiovisuelle;